import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserStoreService } from 'src/app/services/user/user-store.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
const appConfig = require('src/assets/configs/config.json');

@Component({
  selector: 'app-modal-survey',
  templateUrl: './modal-survey.component.html',
  styleUrls: ['./modal-survey.component.scss']
})
export class ModalSurveyComponent implements OnInit {
  cuc: string;
  device: string;
  surveyUrl: SafeResourceUrl;
  isMobile: boolean;

  constructor(
    public userStore: UserStoreService,
    public dialogRef: MatDialogRef<ModalSurveyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  }

  ngOnInit(): void {
    this.cuc = this.userStore.activeCUC.cuc;
    if (this.isMobile) {
      this.device = 'MOVIL'
    } else {
      this.device = 'WEB'
    }
    let url = appConfig.urlSurvey;
    let host = window.location.origin;
    const rutaReemplazada = url.replace("${cuc}", this.cuc).replace("${device}", this.device).replace("${host}", host);
    this.surveyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rutaReemplazada);
  }
}
